import { render, staticRenderFns } from "./QuanHuiParty.vue?vue&type=template&id=230ede8f&scoped=true"
import script from "./QuanHuiParty.vue?vue&type=script&lang=js"
export * from "./QuanHuiParty.vue?vue&type=script&lang=js"
import style0 from "./QuanHuiParty.vue?vue&type=style&index=0&id=230ede8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230ede8f",
  null
  
)

export default component.exports